import React, { Component } from 'react';
class ConsultationOTP extends Component {
  constructor() {
    super();
    this.state = {
    };
  }


  componentDidMount() {

  }

  render() {
    return (
        <>
        <div className="col-md-12">
            <div className="form-floating">
                <input type="text" className="form-control" id="email_otp" name="email_otp" placeholder="Email OTP" maxlength="6"/>
                <label for="name">Email OTP</label>
            </div>
        </div>
        {/*
        <div className="col-md-6">
            <div className="form-floating">
                <input type="text" className="form-control" id="mobile_otp" name="mobile_otp" placeholder="Mobile OTP" maxlength="6"/>
                <label for="name">Mobile OTP</label>
            </div>
        </div>
        */}
        </>
    );
  }
}

export default ConsultationOTP;
